import { render } from "./confirmation-order.vue?vue&type=template&id=2e8ff38d&ts=true"
import script from "./confirmation-order.vue?vue&type=script&lang=ts"
export * from "./confirmation-order.vue?vue&type=script&lang=ts"

import "./confirmation-order.vue?vue&type=style&index=0&id=2e8ff38d&lang=scss"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__